import { render } from "./VideoPlay.vue?vue&type=template&id=1f49dca1&scoped=true&ts=true"
import script from "./VideoPlay.vue?vue&type=script&lang=ts"
export * from "./VideoPlay.vue?vue&type=script&lang=ts"

import "./VideoPlay.vue?vue&type=style&index=0&id=1f49dca1&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f49dca1"]])

export default __exports__